import React from 'react';
import styled from 'styled-components';

const Wrapper  = styled.div.withConfig({displayName:'-Wrapper '})`
`;
const Item  = styled.a`
  display: inline-block;
  background-color: #ffffff;
  color: #0D609D;
  border-radius: 18px;
  width: 18px;
  height: 18px;
  line-height: 1;
  text-align: center;
  margin-right: 3px;
`;

const Socials = ({ inverse }) => {
  return (
    <Wrapper>
      <Item href="https://www.linkedin.com/company/cesi" target="_blank" social="linkedin" inverse={inverse}>
        <img alt="linkedin" src={process.env.PUBLIC_URL + "/icons/social-linkedin.png"} height="18px" />
      </Item>
      <Item href="https://x.com/cesispa" target="_blank" social="twitter" inverse={inverse}>
      <img alt="x" src={process.env.PUBLIC_URL + "/icons/social-x.png"} height="18px" />
      </Item>
    </Wrapper>
  )
}



export default Socials
